function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import systemStore from './addPoint';
import { reportListApi, exportReportApi } from '@/api/marketing';
import { storeListApi } from '@/api/storePoint';
import { checkPermi } from "@/utils/permission"; // 权限判断函数

import addClerkList from "./edit";
export default {
  name: 'report',
  // components: { systemStore },
  components: {
    addClerkList: addClerkList
  },
  data: function data() {
    return {
      options: [{
        id: '0',
        name: '所有'
      }],
      loadingr: false,
      timeVal: [],
      fromList: this.$constants.fromList,
      artFrom: {
        page: 1,
        limit: 20,
        dateLimit: '',
        status: '1',
        store_id: '0',
        keywords: ''
      },
      loading: false,
      tableData: [],
      total: 0,
      headerCount: {},
      editDialogConfig: {
        visible: false,
        data: {},
        isEdit: 0 // 0=add 1=edit

      }
    };
  },
  created: function created() {
    // this.storeGetCount();
    if (this.$store.state.user.storeId) {
      this.artFrom.store_id = this.$store.state.user.storeId;
    }

    this.tableList();
    this.remoteMethod();
    console.log("???????", this.$store.state.user);
  },
  methods: {
    seachList: function seachList(e) {
      console.log(e);
      this.artFrom.page = 1;
      this.tableList();
    },
    remoteMethod: function remoteMethod(query) {
      var _this = this;

      console.log("query", query);

      if (query !== '') {
        this.loadingr = true;
        setTimeout(function () {
          storeListApi({
            keywords: query,
            page: 1,
            limit: 10,
            status: 1
          }).then(function (res) {
            var _this$options;

            _this.loadingr = false;
            _this.options = [{
              id: 0,
              name: '所有'
            }];

            (_this$options = _this.options).push.apply(_this$options, _toConsumableArray(res.list));
          });
        }, 200);
      } else {// this.options = [];
      }
    },
    //方法区
    formatDate: function formatDate(row, column) {
      // 获取单元格数据
      var data = row[column.property];

      if (data == null) {
        return null;
      }

      var dt = new Date(data);
      var month = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1;
      var day = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate();
      var Hours = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
      var minutes = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
      var sec = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds();
      return dt.getFullYear() + '-' + month + '-' + day + ' ' + Hours + ':' + minutes + ':' + sec;
    },
    selectChange: function selectChange(tab) {
      this.artFrom.dateLimit = tab;
      this.artFrom.page = 1;
      this.timeVal = [];
      this.tableList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.artFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.artFrom.page = 1;
      this.tableList();
    },
    //表格列表
    tableList: function tableList() {
      var that = this;
      that.loading = true;
      reportListApi(that.artFrom).then(function (res) {
        that.loading = false;
        that.tableData = res.list;
        that.total = res.total;
      });
    },
    exportList: function exportList() {
      var that = this;
      exportReportApi(that.artFrom).then(function (res) {
        // window.open(res.fileName)
        window.location.href = res.fileName;
      });
    },
    //切换页数
    pageChange: function pageChange(index) {
      this.artFrom.page = index;
      this.tableList();
    },
    //切换显示条数
    sizeChange: function sizeChange(index) {
      this.artFrom.limit = index;
      this.tableList();
    },
    //头部切换
    onClickTab: function onClickTab() {
      this.artFrom.keywords = '';
      this.tableList();
    },
    //搜索
    search: function search() {
      this.artFrom.page = 1;
      this.tableList();
    },
    allDelete: function allDelete(id) {
      var _this2 = this;

      this.$modalSure().then(function () {
        allDeleteApi({
          id: id
        }).then(function () {
          _this2.$message.success('删除成功');

          _this2.storeGetCount();

          _this2.tableList();
        });
      });
    },
    //添加
    add: function add() {
      this.$refs.template.dialogFormVisible = true;
    },
    //编辑
    // edit(id) {
    //   this.$refs.template.dialogFormVisible = true;
    //   this.$refs.template.getInfo(id);
    // }
    edit: function edit(id) {
      this.$refs.template.dialogFormVisible = true; // this.$refs.template.getInfo(id);
    },
    handlerHideDialog: function handlerHideDialog() {
      this.tableList();
      this.editDialogConfig.visible = false;
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this3 = this;

      console.log("rowData", rowData);
      this.$confirm("确定删除当前数据", "提示").then(function (result) {
        DelActivity(rowData).then(function (data) {
          _this3.$message.success("删除数据成功");

          _this3.tableList();
        });
      });
    }
  }
};